<template>
	<div class="product-components" :style="{height:hasLogin?'432px':'355px'}" @click="click">
		<div class="img-box"><img :src="product.pic" /></div>
		<div class="name">{{ product.name }}</div>
		<div class="msg">
			<div class="label">规</div>
			<div class="val">{{ product.speci }}</div>
		</div>
		<div class="msg">
			<div class="label">厂</div>
			<div class="val">{{ product.manufacturers }}</div>
		</div>
		<div class="msg" v-if="hasLogin">
			<div class="label">效</div>
			<div class="val">效期：{{ product.validity ? product.validity : '-'}}</div>
		</div>
		<div class="price-box">
			<div class="price-line" v-if="hasLogin">
				<!-- 4特价、5折扣、6秒杀（限时抢购）-->
				<div class="buy-price"
					v-if="product.activities && product.activities.filter(data => [4, 5, 6].indexOf(data.type) !== -1).length > 0">
					<span class="span">￥</span>
					<template v-if="product.activities.filter(e => e.type == 4).length > 0">
						{{ parseFloat(product.activities.filter(e => e.type == 4)[0].buyPrice) }}
					</template>
					<template v-if="product.activities.filter(e => e.type == 5).length > 0">
						{{ parseFloat((product.activities.filter(e => e.type == 5)[0].discount * product.buyPrice).toFixed(2)) }}
					</template>
					<template v-if="product.activities.filter(e => e.type == 6).length > 0">
						{{ parseFloat(product.activities.filter(e => e.type == 6)[0].buyPrice) }}
					</template>
				</div>
				<div class="buy-price" v-else>
					<span class="span">￥</span>
					{{ product.buyPrice }}
				</div>
				<!-- 划线价 活动4和5展示-->
				<div class="underlined-price"
					v-if="product.activities && product.activities.filter(data => [4, 5, 6].indexOf(data.type) !== -1).length > 0">
					<span class="underlined-price-span">￥</span>{{ product.buyPrice }}
				</div>
			</div>
			<div class="tip" v-else>价格登录后可见</div>
		</div>
		<!-- 活动 type =（0：全场券；1：单品券；2：买赠；3：满减；4：特价；5：折扣；6：秒杀；7：限购）-->
		<div class="activity-box"
			v-if="product.activities && product.activities.filter(data => [2, 3, 4, 5, 6, 7].indexOf(data.type) !== -1).length > 0">
			<div class="activity-line"
				v-for="(activityItem, index) in product.activities.filter(data => [2, 3, 4, 5, 6, 7].indexOf(data.type) !== -1)"
				:key="index">
				<span class="activity-single" v-if="activityItem.type == 2">买赠</span>
				<span class="activity-single"
					v-if="activityItem.type == 3">满{{parseFloat(activityItem.minPoint)}}减{{parseFloat(activityItem.amount)}}</span>
				<span class="activity-single" v-if="activityItem.type == 4">特价</span>
				<span class="activity-single"
					v-if="activityItem.type == 5">限时{{ parseFloat(10 * activityItem.discount) }}折</span>
				<span class="activity-single" v-if="activityItem.type == 6">限时抢购</span>
				<span class="activity-single" v-if="activityItem.type == 7">限购
					<span v-if="activityItem.perLimit && activityItem.perLimit < 999">
						{{ activityItem.perLimit }}件
					</span>
				</span>
			</div>
		</div>
		<div class="msg" v-if="hasLogin && product.retailPrice">
			<div class="val retailPrice">建议零售价￥{{ product.retailPrice }}</div>
		</div>
	</div>
</template>

<script>
	import {
		mapGetters
	} from 'vuex';

	export default {
		name: "product-components",
		props: {
			product: {
				type: Object,
				default: () => {
					return {};
				}
			}
		},
		computed: {
			...mapGetters(['hasLogin']),
		},
		methods: {
			click() {
				this.$emit('click', this.product);
			}
		}
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	@import "@/assets/css/szui.scss";

	.product-components {
		margin-top: 20px;
		padding: 10px;
		width: 232px;
		height: 432px;
		background: #FFFFFF;
		border-radius: 10px;
		cursor: pointer;

		.img-box {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 212px;
			height: 212px;
			background: #FFFFFF;
			border: 1px solid #EDEFF2;
			border-radius: 10px;
			overflow: hidden;

			img {
				width: 100%;
			}
		}

		.name {
			margin-top: 10px;
			margin-bottom: 2px;
			line-height: 1.3;
			font-size: 18px;
			font-weight: bold;
			color: $fontColor;
			overflow: hidden;
			text-overflow: ellipsis;
			white-space: nowrap;
		}

		.msg {
			display: flex;
			justify-content: flex-start;
			align-items: center;
			margin-top: 6px;

			.label {
				flex-shrink: 0;
				display: flex;
				justify-content: center;
				align-items: center;
				width: 20px;
				height: 20px;
				background: #FFFFFF;
				border: 1px solid #C0C4CC;
				border-radius: 5px;

				font-size: 13px;
				font-weight: 400;
				color: #909399;
			}

			.val {
				margin-left: 4px;
				line-height: 1.2;
				font-size: 14px;
				font-weight: 400;
				color: #909399;
				overflow: hidden;
				text-overflow: ellipsis;
				white-space: nowrap;
			}

			.retailPrice {
				margin-left: 0;
				margin-top: 2px;
			}
		}

		.price-box {
			display: flex;
			justify-content: space-between;
			align-items: flex-end;
			margin-top: 10px;

			.price-line {
				display: flex;
				align-items: baseline;
				line-height: 1;

				.buy-price {
					font-size: 22px;
					font-weight: bold;
					color: #EE3C20;
				}

				.span {
					line-height: 1;
					font-size: 16px;
					font-weight: bold;
					margin-right: -5px;
				}
			}

			.underlined-price {
				margin-left: 8px;
				line-height: 1;
				font-size: 16px;
				color: #909399;
				text-decoration: line-through;
			}

			.tip {
				font-size: 15px;
				color: #ee3c20;
			}
		}

		.activity-box {
			margin-top: 10px;

			.activity-line {
				display: flex;
				flex-wrap: wrap;
				flex: 1;

				.activity-single:last-child {
					margin-right: 0 !important;
				}

				.activity-single {
					margin-right: 8px;
					display: flex;
					justify-content: center;
					align-items: center;
					height: 22px;
					padding: 0px 4px;
					background: #FFF6ED;
					border-radius: 4px;
					border: 1px solid #FF6642;
					font-size: 14px;
					color: #FF6642;
				}
			}
		}
	}
</style>